module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2d"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter1"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("SO HERE YOU ARE, leafing through "), _c('em', [_vm._v("The Complete Guide to Vegan Food Substitutions.")]), _vm._v(" Welcome! No matter what your reasons for wanting a change, the fact remains that you’re doing something for your health, the good of the animals, as well as the planet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A guide to vegan food substitutions has never been more needed, considering the number of people who are choosing to make lifestyle changes for ethical or environmental reasons. Equally important are those who have no choice but to completely overhaul their eating habits due to health issues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With so many ways to replace traditional ingredients with those that are free of animal products and allergens, you will soon wonder why anyone would even bother with the less healthy, not cruelty-free versions in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We created this book to unveil the mysteries of vegan food substitutions, to make it possible for the everyday home cook to create dairy-free, egg-free, meat-free, and animal-free dishes that are both delicious and kind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You may have family recipes going back several generations and feel like giving them a healthier, animal-friendly spin. While you could simply go out and try to find a vegan cookbook that contains a somewhat similar recipe, there is enormous and lasting satisfaction that comes from knowing that pretty much any dish can be made vegan using your own hands and your own set of cooking and baking skills. That’s the goal of our book: to give you the know-how and confidence to transform any traditional recipe you come across— and have the dish turn out delicious, healthy, and kind every single time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout this book, we will teach you how to make your own, or shop for simple ingredient swaps that “veganize” your favorite recipes. We will give you recommendations on particular products and brands that have performed well in our kitchens. Then, at the start of each chapter, we will walk you through a traditional recipe and point out precisely what we would do to make it vegan. Before you know it, you’ll have that same ability— allowing you to look at any recipe and instantly translate it for the vegan chef.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’re big fans of making our food from scratch. It’s usually cheaper and so important to know exactly what goes into our food. As a bonus, we can also take full credit for the outcome! That being said, we find that the quality of some items have yet to be rivaled in the home kitchen, so, for instance, we stick to the store-bought kind of cream cheese and other melt-y cheeses. And in other instances, we’re just too lazy to bother making things like tofu and tempeh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enough preambles; let’s get started on this tasty trip into the magical world of vegan food substitutions! (Unicorns not included.)")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("A Note on Food Allergies")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We cannot stress enough how vital it is that you keep an extremely close eye on the ingredients you use before making a recipe that is labeled as being gluten-, nut-, soy-free, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While we have done our best to label said recipes, allergens still have a way of sneaking into ingredients that you’d expect to be respectful of the restrictions you have to follow. You are your best advocate. We care about your health, so please use extreme caution. Throughout this book you will find recipes labeled in the following way:")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/corn.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Corn Free:")]), _vm._v(" Recipes that do not contain corn.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/cook.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("For the More Experienced Cook:")]), _vm._v(" Recipes that take a little more time and are best enjoyed on days when you have more freedom. Or, that could be prepared in several steps, on several different occasions, to cut back on cooking and/or baking time.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/gul.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Gluten Free:")]), _vm._v(" Recipes that do not contain gluten. Double-check ingredient labels. Recipes that contain certain ingredients such as vinegars, grain alcohol, and flavor extracts (such as vanilla) may be labelled as gluten free. Use your best judgment when consuming these products, and search out certified gluten free ingredients when preparing foods for those with gluten sensitivity. For more information regarding gluten free ingredients, visit Celiac.com.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/low.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Low Fat:")]), _vm._v(" Recipes that contain three grams (the equivalent of 27 fat calories) of fat, or less, per serving.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/nut.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Nut Free:")]), _vm._v(" Recipes that do not contain nuts. Double-check ingredient labels.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/quick.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Quick and Easy:")]), _vm._v(" Recipes that take less than thirty minutes to whip up, provided you have intermediate cooking and/or baking skills.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/raw.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Raw:")]), _vm._v(" Recipes that only contain raw ingredients or ingredients not heated to temperatures above 118°F (48°C).")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/soy.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Soy Free:")]), _vm._v(" Recipes that do not contain soy. Double-check ingredient labels.")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/wheat.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Wheat Free:")]), _vm._v(" Recipes that do not contain wheat. Double-check ingredient labels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Throughout the book you will also see the following symbols, which highlight the main substitute in each recipe, according to the subject matter of that chapter, so that you can easily detect what works where and how:")]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/dairy.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Dairy Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/chees.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Cheese Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/egg.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Egg Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/meat.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Meat Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/fish.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Fish Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/honey.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("By-product Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/gulten.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Gluten Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/soy1.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Soy Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/suger.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Sugar Sub")])]), _vm._v(" "), _c('p', {
    staticClass: "indentbullet"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/fat.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Fat Sub")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you flip through the pages of this book, you may come across ingredients you are not be familiar with. That’s okay; it’s all part of the process. Most of the ingredients used in this book can be found in any supermarket—and stores make it easy on us vegans by grouping most of the vegan cheeses, yogurts, faux-meats, mayos, and other items together, usually in the produce department alongside the tofu. The less common ingredients may require a trip to your local health-food store or co-op, and if you’re unable to find a particular ingredient in your area, a quick Internet search should give you many options.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Below is a list of ingredients that may require extra explanation and a brief description of how we use them throughout this book. More in-depth descriptions of certain ingredients appear in each of the chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Beans:")]), _vm._v(" For convenience’s sake, we like to use canned beans, rinsing and draining them thoroughly to get rid of unnecessary extra sodium. If you prefer cooking your own, more power to you! Keep in mind that one 15-ounce (425 g) can of beans generally equals approximately 12/3 cups (294 g) cooked beans, or 2/3 cup (120 g) dry beans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Chia Seeds:")]), _vm._v(" Small mild-flavored seeds, usually dark gray or black in color, that become gelatinous when combined with liquid, making them an excellent thickening agent in puddings, dressings, and even crackers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Flours:")]), _vm._v(" Scooping vs. lightly spooning? We’re of the lightly spooning and scraping school. This means that we use a spoon to transfer flours into the measuring cup, so as not to overpack the stuff. It can make a difference in how recipes turn out, so it’s a good thing to keep in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for the kind of flour we prefer, we like to get as much nutrition out of our food as we possibly can, no matter how sinful or healthy the recipe. That’s why we generally use whole wheat pastry flour for our baked goods. If whole wheat pastry flour is hard to find, you can simply combine equal amounts of unbleached all-purpose and whole wheat flours to get the same results. Of course, you can go with all-purpose flour only, if you want baked goods that are truest to form.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('strong', [_vm._v("Liquid smoke:")]), _vm._v(" A flavoring that’s stocked near the marinades in most markets. Actually made by condensing smoke into liquid form. A little goes a long way in giving a smoky flavor to many foods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Maca powder:")]), _vm._v(" A dried root that is somewhat of a superfood, since it is packed with vitamins (B), minerals (including calcium), and amino acids, and is said to increase stamina, reduce fatigue, and even enhance libido. It is rather expensive, but a little goes a long way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Nondairy milks:")]), _vm._v(" We like ours to be unsweetened so that it lends itself to pretty much any use, but we aren’t too picky on which kind: soy, almond, rice, hemp . . . They’re all tasty but you will have to do a taste-testing for yourself, as both brands and personal preference might play a role here. When it comes to making buttermilk for baking by combining nondairy milk and vinegar or lemon juice, we find that soy is the best option. Please have a look at "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("chapter 1")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#page_16"
    }
  }, [_vm._v("page 16")]), _vm._v(") for more on nondairy milks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Nut butters:")]), _vm._v(" We love them all, as long as they’re made of nothing but nuts or at most have a little bit of added salt. Please have a look at "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("chapter 1")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#page_17"
    }
  }, [_vm._v("page 17")]), _vm._v(") for more on nut butters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Nutritional yeast:")]), _vm._v(" The magical, nonactive kind of yeast most vegans adore. Its nutty and cheesy flavor is a bit of an acquired taste, so give yourself time to get used to it, and you might find yourself hopelessly addicted to it like many others before you. Look for the vegetarian-support formula (this will be noted on the label), as it is enriched in vitamin B"), _c('sub', [_vm._v("12")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Oils:")]), _vm._v(" We generally use neutral-flavored vegetable oils (such as canola, vegetable, peanut, etc.) in baking, unless otherwise mentioned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Canola oil has a bit of a bad reputation due to GMO issues, so you can opt for peanut or vegetable oil, but the choice is up to you and depends on what you can afford or what your health conscience tells you. When it comes to cooking, we like to use extra-virgin olive oil on salads, and peanut oil for dishes that involve a long frying time as it has a high-smoke point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are two camps when it comes to coconut oil: Some people think it’s highly unhealthy, while others swear by it and think it can cure pretty much any ailment—and save your marriage, too. We’re all for moderation and actually like the stuff, so you will find a few recipes in this book that list it as an ingredient: Again, do what your conscience and wallet tell you, and substitute away! It is, after all, the purpose of this book to show you that recipes do not have to be rigid, and that you can develop your own guidelines for what sounds and tastes right to you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Salt")]), _vm._v(" and "), _c('strong', [_vm._v("pepper:")]), _vm._v(" We like to respect your habits when it comes to salt and pepper, so the measurements you will find in our recipes are meant as a guide. We usually add “to taste” so that you can follow your needs and preferences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We prefer using sea salt, as it retains a minuscule amount of minerals. And we like to use a small amount of black salt in recipes that replicate eggs, to lend them a delicate sulfurous flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Seaweed,")]), _vm._v(" such as "), _c('strong', [_vm._v("hijiki, dulse,")]), _vm._v(" and "), _c('strong', [_vm._v("nori:")]), _vm._v(" Edible seaweeds add a fishy flavor to foods without using fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('strong', [_vm._v("Soy sauce:")]), _vm._v(" Can be replaced with tamari or Bragg Liquid Aminos. If you’re watchful of your sodium intake, purchase the reduced-sodium kind. The liquid aminos only contain a small amount of natural sodium and happen to be gluten free. The flavor and cost, however, may take a little getting used to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Sriracha")]), _vm._v(" or "), _c('strong', [_vm._v("“Rooster Sauce”:")]), _vm._v(" An addictive hot sauce made from chili peppers, garlic, vinegar, and salt ground together to form a smooth paste. Check for ingredients, as some brands contain fish sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Sweeteners:")]), _vm._v(" We have used a wide selection of sweeteners in this book to show you their different uses and qualities. We most commonly use evaporated cane juice (in place of granulated white sugar), brown sugar, Sucanat, and raw sugar. As for the liquid sweeteners, we’re big fans of agave nectar, pure maple syrup, and brown rice syrup. We have also dabbled in calorie-free all-natural sweeteners such as stevia and xylitol. Please have a look at "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 8")]), _vm._v(" ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#page_226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 226")]), _vm._v(") to get more information about our most commonly used types of sweetening agents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Tamarind paste:")]), _vm._v(" We love to use this sour condiment, but the type we find at the international food store isn’t made of 100 percent tamarind and therefore a bit milder than pure tamarind paste. Adjust amounts according to what you can find and to your liking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Tofu")]), _vm._v(" and "), _c('strong', [_vm._v("tempeh:")]), _vm._v(" Silken, soft, medium, firm, extra firm, even super firm! We use silken for desserts and sauces, and prefer firm or even firmer to fry or bake. Keep in mind it’s best to press your tofu if you’re going to fry it, as it makes for a chewier, meatier texture. Here’s an easy method: drain any liquid from the block of tofu and then sandwich it between either two folded kitchen towels or several folded layers of paper towels and place a heavy object, such as a book or frying pan, on top to press out excess moisture. Allow to sit for about an hour to press. Please have a look at "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(" ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 109")]), _vm._v(") for more information about tofu and tempeh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Vital wheat gluten:")]), _vm._v(" A perfect source of protein to make delicious seitan (the glorious wheat meat), or used in breads to improve texture, gluten is the natural protein portion removed from whole wheat. It can be found in most grocery stores these days or ordered online. It is important to know that vital wheat gluten flour is completely different from high gluten flour. The two are not interchangeable and will not perform similarly in recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Xanthan gum:")]), _vm._v(" Don’t let the name scare you: This natural carbohydrate that is produced from corn or cabbage does wonders for gluten-free baking and cooking by adding volume to the goods. Available at most health-food stores or online, one bag should last you a very long time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Please have a look at "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v(" ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 173")]), _vm._v(") for more information about xanthan gum.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17119889","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter1.vue
// module id = 66
// module chunks = 0